import type { Place } from '../types/warehouse.types';

export const selectRandomPlaces = (
  places: Map<string, Place>,
  count: number
): string[] => {
  const placeIds = Array.from(places.keys());
  const shuffled = [...placeIds].sort(() => 0.5 - Math.random());
  return shuffled.slice(0, Math.min(count, placeIds.length));
};

export const delay = (ms: number): Promise<void> => {
  return new Promise(resolve => setTimeout(resolve, ms));
};
